import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { Breadcrumb, breadcrumbState } from 'recoils/atoms'

const useBreadcrumbs = (breadcrumbs: Breadcrumb[]): void => {
  const setBreadcrumbs = useSetRecoilState(breadcrumbState)

  useEffect(() => {
    setBreadcrumbs(breadcrumbs)

    return () => {
      setBreadcrumbs([])
    }
  }, [])
}

export default useBreadcrumbs
